import React from 'react';
import { connect } from 'react-redux';
import checkList from 'assets/images/backoffice/capital/checklist.png';
import { changePageApplication, pageRequestDashboard } from 'actions/capital';
import * as clevertapCapital from 'clevertap/capital';
import styles from './Submitted.css';

class Submitted extends React.Component {
  render() {
    const title = 'Application submitted';
    const description =
      "Thank you for submitting your application. You'll be informed about your loan application status in 3-5 business days on your Moka Capital dashboard and through an email";
    return (
      <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding`}>
        <div className={`${styles['full-height-capital']}`}>
          <div
            className={`${
              styles['application-submitted-container']
            } box-spinner`}
          >
            <div className={`${styles['content-application-submitted']}`}>
              <div>
                <h3 className={styles.title}>{title}</h3>
              </div>
              <div>
                <img src={checkList} className={`${styles['checklist-img']}`} />
              </div>
              <div
                className={`${styles.description} ${
                  styles['description-box']
                } col-md-9 col-lg-9`}
              >
                <p>{description}</p>
              </div>
              <div className={styles['btn-dashboard-container']}>
                <a
                  className={`btn ${styles['btn-go-to-dashboard']}`}
                  onClick={this._onClickGotoDashboard}
                >
                  Go to Capital Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickGotoDashboard = () => {
    clevertapCapital.backToDashBoard();
    this.props.dispatch(changePageApplication(1));
    this.props.dispatch(pageRequestDashboard());
  };
}

export default connect()(Submitted);
